// @storybook-internal widget renderer catalogued through PlacedWidgetItem.
import React, { useMemo } from "react";
import "./widget-cards.css";

import type { T_ChatV8ChartWidgetSnapshotData } from "@lattice/core-lib/types/chat-v8";
import { formatChatV8ChartAsOfLine } from "@lattice/shared-frontend/chat-v8";

import { ChartRenderer } from "@lattice/frontend/components/charts-kit/ChartRenderer";
import { validateChartData } from "@lattice/frontend/components/charts-kit/chart-data";

export type T_ChartWidgetCardProps = {
  data: T_ChatV8ChartWidgetSnapshotData;
};

/** Web mirror of the mobile ChartWidgetCard: charts-kit renderer (which
 * dispatches z_ChartData.presentation) plus the source note. */
export function ChartWidgetCard({ data }: T_ChartWidgetCardProps) {
  const result = useMemo(() => validateChartData(data.chart), [data.chart]);

  return (
    <div className="cw-plain">
      {result.success ? (
        <ChartRenderer chart={result.data} />
      ) : (
        <p className="cw-muted">This chart could not be rendered.</p>
      )}
      <p className="cw-muted">{formatChatV8ChartAsOfLine(data.asOf)}</p>
    </div>
  );
}
